import { useEffect, useState } from "react";
import type { TocItem } from "@/lib/blog/toc";

export function BlogTOC({ items }: { items: TocItem[] }) {
  const [active, setActive] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window === "undefined" || items.length === 0) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible.length > 0) setActive(visible[0].target.id);
      },
      { rootMargin: "-96px 0px -70% 0px", threshold: [0, 1] },
    );
    const els: HTMLElement[] = [];
    for (const it of items) {
      const el = document.getElementById(it.id);
      if (el) {
        observer.observe(el);
        els.push(el);
      }
    }
    return () => {
      for (const el of els) observer.unobserve(el);
      observer.disconnect();
    };
  }, [items]);

  if (items.length < 2) return null;
  return (
    <nav aria-label="Contents" className="text-sm">
      <div className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold mb-2">Contents</div>
      <ul className="space-y-1 border-l border-slate-200">
        {items.map((it) => {
          const isActive = active === it.id;
          return (
            <li key={it.id} className={it.level === 3 ? "pl-4" : ""}>
              <a
                href={`#${it.id}`}
                className={`block -ml-px border-l-2 pl-3 py-1 transition ${
                  isActive
                    ? "border-[#172554] text-[#172554] font-semibold"
                    : "border-transparent text-slate-500 hover:text-slate-800"
                }`}
              >
                {it.text}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}